(function () {
  'use strict';

  directive.$inject = ["$modal", "$rootScope", "FORMAT", "PATH", "apiService", "numberService", "alertService"];
  app.directive('applyTransaction', directive);

  function directive($modal, $rootScope, FORMAT, PATH, apiService, numberService, alertService) {
    return {
      scope: {
        transaction: '=',
        afterApply: '&',
        bills: '=?',
        showOnInit: '=?',
        beforeApply: '&?',
        afterClose: '&?'
      },
      restrict: 'A',
      link: function ($scope, $element) {
        var modal;
        var modalScope;

        /*
          init show apply modal
        */

        $scope.isBillCreditMode = $scope.transaction.type === 'bill';
        if ($scope.showOnInit) {
          showApplyModal();
        } else {
          $element.on('click', showApplyModal);
        }

        function showApplyModal() {
          modalScope = $rootScope.$new(true);
          modalScope.moneyFormat = FORMAT.money;
          modalScope.orderProperty = 'dateString';
          modalScope.reverse = false;

          modalScope.transaction = $scope.transaction;
          modalScope.isBillCreditMode = $scope.isBillCreditMode;
          modalScope.title = modalScope.isBillCreditMode ? 'credit' : 'payment';
          modalScope.loading = {};

          modalScope.submit = submit;
          modalScope.onAmountChange = function (item) {
            var unpaid = angular.copy(item.applyData.amountUnpaid);
            item.applyData.amountLeft = numberService.subtract(unpaid, item.applyData.payment.amount || 0);
            validateAmount(item);
            modalScope.totals = calcTotals(modalScope.items);
            validateTotals(modalScope.totals);
          };

          modalScope.close = function () {
            if ($scope.afterClose) $scope.afterClose();
            modal.hide();
          };

          modal = $modal({
            scope: modalScope,
            templateUrl: PATH.components + '/applyTransaction/modal.apply.html'
          });

          modalScope.loadingPayments = {};

          $scope.transaction.payments = $scope.transaction.payments || [];
          if (!modalScope.isBillCreditMode && !modalScope.transaction.payments.length) {
            apiService.getSome('billpayment/dto/transaction/' + $scope.transaction.id, modalScope.loadingPayments)
              .then(function (res) {
                $scope.transaction.payments = res.data;
                setData();
              });
          } else {
            modalScope.loadingPayments = { request: { isSuccess: true } };
            setData();
          }

          function setData() {
            var billsToShow;

            if (!modalScope.isBillCreditMode) {
              billsToShow = getManualTransactionBills();
              modalScope.amountAvailable = $scope.transaction._amount;
            } else {
              billsToShow = getBillCreditTransactionBills();
              var amountPaidWithBillPayments = _.sumBy($scope.transaction.payments, function (payment) {
                return payment.creditPaymentRelationshipID && payment.billPaymentAmount;
              });
              modalScope.amountAvailable = $scope.transaction._amount - amountPaidWithBillPayments;
            }

            modalScope.items = formatBills(billsToShow, $scope.transaction.id);
            modalScope.items = _.filter(modalScope.items, function (item) {
              return item.applyData.payment.amount || item.applyData.amountLeft;
            });
            matchSimilar(modalScope.items);
            modalScope.totals = calcTotals(modalScope.items);
            if ($scope.beforeApply) $scope.beforeApply();
          }
        }

        function getManualTransactionBills() {
          var unpaidVendorBills = $scope.transaction.vendor.bills;
          var paidVendorBillsByTransaction = [];

          _.forEach($scope.transaction.payments, function (payment) {
            if (!_.find(unpaidVendorBills, { id: payment.bill.id })) {
              paidVendorBillsByTransaction.push(payment.bill);
            }
          });

          return paidVendorBillsByTransaction.concat(unpaidVendorBills);
        }

        function getBillCreditTransactionBills() {
          return _.filter($scope.bills, function (bill) {
            if (bill.transaction.vendor.id !== modalScope.transaction.vendor.id) return;
            if (bill.status === 'Unpaid') return bill;
            if (bill.status === 'Paid') {
              return _.find(modalScope.transaction.payments, function (payment) {
                return payment.bill.id === bill.id && !payment.creditPaymentRelationshipID;
              });
            }
          });
        }

        function formatBills(bills, transactionId) {
          _.each(bills, function (item) {
            var payment = _.find(item.payments, function (p) {
              return p.transaction && p.transaction.id === transactionId && !p.creditPaymentRelationshipID;
            }) || { billPaymentAmount: 0 };
            payment.amount = payment.billPaymentAmount;

            var amountToPay = (item.amount || item.amount === 0) && numeral(item.amount) ||
              numeral(numberService.sumOptional(item.transaction.transactionDetails, 'amount'));

            var amountPaid = numberService.toFixed(_.reduce(item.payments, function (sum, p) {
              var isActive = p.transaction && !(p.transaction.isVoided || p.voidTransactionID);
              return isActive ? (sum + p.billPaymentAmount) : sum;
            }, 0));

            var amountLeft = numberService.subtract(angular.copy(amountToPay), amountPaid);

            item.applyData = {
              date: moment(item.transaction.dateString, FORMAT.dateApi).format('MM/DD/YY'),
              amount: amountToPay.value(),
              amountLeft: amountLeft,
              amountUnpaid: numberService.add(amountLeft, payment.amount),
              payment: payment,
              errors: {}
            };
            item.amount = amountToPay.value();
          });

          return bills;
        }

        function matchSimilar(items) {
          var totals = calcTotals(items);
          var left = numberService.subtract(modalScope.amountAvailable, totals.payment);

          if (!left) return;

          var similar = _.find(items, function (item) {
            return item.applyData.amountLeft === left && !item.applyData.payment.amount;
          });

          if (similar) {
            similar.applyData.payment.amount = left;
            similar.applyData.amountLeft = 0;
          }
        }

        /*
          Helper
        */

        function calcTotals(items) {
          var totals = {
            payment: numeral(0),
            needed: numeral(0),
            left: numeral(0)
          };

          _.each(items, function (item) {
            totals.payment.add(item.applyData.payment.amount);
            totals.needed.add(item.applyData.amountUnpaid);
            totals.left.add(item.applyData.amountUnpaid).subtract(item.applyData.payment.amount);
          });

          return totals;
        }

        /*
          Validation
        */

        function validateAmount(item) {
          item.applyData.errors.amount = item.applyData.payment.amount < 0 || item.applyData.amountLeft < 0;
          return item.applyData.errors.amount;
        }

        function validateTotals(totals) {
          totals.error = numberService.subtract(totals.payment.value(), modalScope.amountAvailable) > 0;
        }

        /*
          Submission
        */

        function submit(items, totals, loading) {
          var hasInvalidItem = _.find(items, validateAmount);
          validateTotals(totals);
          if (!hasInvalidItem && !totals.error) {
            var data = makePostData(items);
            if (!data.create.length && !data.delete.length && !data.update.length) {
              modal.hide();
            } else {
              var params = modalScope.isBillCreditMode ? '?isVendorCredit=true' : '';

              apiService.postSome('billpayment/apply' + params, data, loading)
                .then(function (response) {
                  // eslint-disable-next-line no-shadow
                  var data = response.data;
                  items = updateAffect(items, data.affectedBills, data.affectedPayments);

                  /*
                    update payments in each bill:
                      remove 0 amount payment
                      add new payment
                      update payment

                    update payment in transaction:
                      remove 0 amount
                      add new payment
                      update payment

                    update vendor bills list:
                      remove bills that were 'Unpaid' and become 'Paid'
                      add bills that were 'Paid' and become 'Unpaid' + format them

                    update item bills:
                      change bills status
                      add bill to payment which became 'paid'
                  */
                  var payments = data.payments;
                  var unpaidBills = [];

                  _.forEach(items, function (item) {
                    var payment = item.applyData.payment;
                    if (payment.id) {
                      if (!payment.amount) {
                        // remove 0 payment from bill payments
                        _.remove(item.payments, { id: payment.id });
                        _.remove($scope.transaction.payments, { id: payment.id });
                      } else {
                        // update billPaymentAmount if amount updated
                        _.find(item.payments, { id: payment.id }).billPaymentAmount = payment.amount;
                        _.find($scope.transaction.payments, { id: payment.id }).billPaymentAmount = payment.amount;
                      }
                    } else if (payment.amount) {
                      // add payment to unpaid bills
                      payment = _.find(payments, function (p) {return p.bill.id === item.id;});
                      item.payments.push(payment);
                      $scope.transaction.payments.push(payment);
                    }

                    item.status = item.applyData.amountLeft ? 'Unpaid' : 'Paid';
                    if (item.status === 'Paid') {
                      _.find($scope.transaction.payments, { id: payment.id }).bill = {
                        id: item.id,
                        status: 'Paid',
                        dateString: item.transaction.dateString,
                        billReferenceNumber: item.billReferenceNumber,
                        transaction: item.transaction,
                        payments: item.payments,
                        lastUpdatedString: item.lastUpdatedString
                      };
                    } else {
                      unpaidBills.push(item);
                    }
                  });

                  modalScope.items.forEach(function (item) {
                    delete(item.applyData);
                  });

                  if (!$scope.isBillCreditMode) {
                    $scope.transaction.vendor.bills = unpaidBills;
                    $scope.transaction.transactionDetails = data.transaction.transactionDetails;
                    if ($scope.transaction.beforeEdit) $scope.transaction.beforeEdit.transactionDetails = data.transaction.transactionDetails;
                    // change type to applied or default
                    if ($scope.transaction.payments.length) {
                      $scope.transaction.type = 'applied';
                      if ($scope.transaction.beforeEdit) $scope.transaction.beforeEdit.type = 'applied';
                    } else {
                      delete($scope.transaction.type);
                      if ($scope.transaction.beforeEdit) delete($scope.transaction.beforeEdit.type);
                    }
                  }

                  $scope.afterApply();
                  modal.hide();
                }, function (err) {
                  alertService.error(err[0].errorMessage);
                });
            }
          }
        }

        function updateAffect(items, affectedBills, affectedPayments) {
          return items.map(function (item) {
            affectedBills.forEach(function (billItem) {
              if (item.id === billItem.id) {
                item.lastUpdatedString = billItem.lastUpdatedString;
              }
            });

            item.payments.forEach(function (payment) {
              affectedPayments.forEach(function (payItem) {
                if (payment.id === payItem.id) {
                  payment.lastUpdatedString = payItem.lastUpdatedString;
                }
              });
            });
            return item;
          });
        }

        function makePostData(items) {
          var data = {
            create: [],
            update: [],
            delete: []
          };
          _.forEach(items, function (item) {
            var params = {
              id: item.applyData.payment.id,
              billPaymentAmount: item.applyData.payment.amount,
              bill: { id: item.id },
              transaction: { id: $scope.transaction.id }
            };

            if (item.applyData.payment.id) {
              if (!item.applyData.payment.amount) {
                params.lastUpdatedString = item.applyData.payment.lastUpdatedString;

                data.delete.push(params);
              } else {
                params.lastUpdatedString = item.applyData.payment.lastUpdatedString;
                params.bill.lastUpdatedString = item.lastUpdatedString;

                data.update.push(params);
              }
            } else if (item.applyData.payment.amount) {
              params.bill.lastUpdatedString = item.lastUpdatedString;

              data.create.push(params);
            }
          });
          return data;
        }
      }
    };
  }
})();



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/applyTransaction/directive.js